import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import { Ionicons, Feather } from '@expo/vector-icons';
import Text from '../text';

const SortList = (props) => {
  const {
    data = [],
    height = 38,
    width,
    title,
    setSort,
    renderTitle = 'Sort',
    accordionOpenVal = false,
  } = props;

  const [open, setOpen] = useState(accordionOpenVal);

  useEffect(() => {
    setOpen(accordionOpenVal);
  }, [accordionOpenVal]);

  const displayTitle = typeof renderTitle === 'object' ? (renderTitle?.name || 'Sort') : (renderTitle || 'Sort');

  const handleSelect = (item) => {
    if (setSort) {
      setSort(item.name, item.value);
    }
    setOpen(false);
  };

  return (
    <View style={[styles.wrapper, width ? { width } : null]}>
      <TouchableOpacity
        style={[styles.triggerBtn, { height }]}
        onPress={() => setOpen(!open)}
        activeOpacity={0.8}
      >
        <View style={styles.triggerLeft}>
          <Feather name="sliders" size={13} color="#6C2BD9" style={{ marginRight: 6 }} />
          {title ? <Text style={styles.prefixTitle}>{title}: </Text> : null}
          <Text style={styles.labelText} numberOfLines={1}>
            <Text style={styles.sortPrefix}>Sort by: </Text>
            {displayTitle}
          </Text>
        </View>
        <Ionicons
          name={open ? 'chevron-up' : 'chevron-down'}
          size={14}
          color="#6B7280"
          style={{ marginLeft: 6 }}
        />
      </TouchableOpacity>

      {open && (
        <>
          {/* Backdrop overlay to close when clicking outside */}
          <TouchableOpacity
            style={styles.backdrop}
            activeOpacity={1}
            onPress={() => setOpen(false)}
          />

          {/* Floating Dropdown Card */}
          <View style={styles.dropdownCard}>
            {data.map((item, index) => {
              const isSelected = item.name === displayTitle;
              return (
                <TouchableOpacity
                  key={index}
                  style={[styles.itemRow, isSelected && styles.itemRowSelected]}
                  onPress={() => handleSelect(item)}
                  activeOpacity={0.7}
                >
                  <Text style={[styles.itemText, isSelected && styles.itemTextSelected]}>
                    {item.name}
                  </Text>
                  {isSelected && (
                    <Ionicons name="checkmark" size={15} color="#6C2BD9" />
                  )}
                </TouchableOpacity>
              );
            })}
          </View>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    position: 'relative',
    zIndex: 9999,
  },
  triggerBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#FFFFFF',
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    paddingHorizontal: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 3,
    elevation: 1,
  },
  triggerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  prefixTitle: {
    fontSize: 12,
    color: '#6B7280',
    fontWeight: '600',
  },
  labelText: {
    fontSize: 13,
    fontWeight: '700',
    color: '#111827',
  },
  sortPrefix: {
    fontSize: 12,
    color: '#6B7280',
    fontWeight: '400',
  },
  backdrop: {
    position: 'absolute',
    top: -1000,
    left: -1000,
    right: -1000,
    bottom: -1000,
    zIndex: 9998,
    backgroundColor: 'transparent',
  },
  dropdownCard: {
    position: 'absolute',
    top: 44,
    right: 0,
    minWidth: 170,
    backgroundColor: '#FFFFFF',
    borderRadius: 14,
    paddingVertical: 6,
    borderWidth: 1,
    borderColor: '#F3F4F6',
    zIndex: 9999,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 6,
  },
  itemRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 8,
    marginHorizontal: 4,
    marginVertical: 1,
  },
  itemRowSelected: {
    backgroundColor: '#F0E8FF',
  },
  itemText: {
    fontSize: 13,
    color: '#374151',
    fontWeight: '500',
  },
  itemTextSelected: {
    color: '#6C2BD9',
    fontWeight: '700',
  },
});

SortList.propTypes = {
  data: PropTypes.array,
  renderTitle: PropTypes.any,
  title: PropTypes.string,
  setSort: PropTypes.func,
  width: PropTypes.any,
  height: PropTypes.any,
  accordionOpenVal: PropTypes.bool,
};

export default SortList;
